export default __webpack_public_path__ + "static/media/NW0888.34I-35130_-20425_0.74245f7a.jpg";